import { ToastContainer } from 'react-toastify';
import styled, { css } from 'styled-components';

const sharedToastStyle = css`
  display: flex;
  padding: 12px 20px;
  border-radius: 5px;
  width: fit-content;
  margin: 0 auto 16px auto;
  button[aria-label='close'] {
    display: flex;
    align-items: center;
    height: 100%;
    opacity: 1;
    align-self: center;
  }
`;

export const StyledToastContainer = styled(ToastContainer)`
  .Toastify__overwrite-body {
    margin: 0 8px 0 0;
    font-size: 14px;
    padding: 0px;
  }
  &&&.Toastify__toast-container--top-center {
    width: fit-content;
    max-width: 480px;
  }
  .Toastify__toast {
    min-height: 35px;
    min-width: 280px;
  }
  .Toastify__overwrite-success {
    ${sharedToastStyle}
    background-color: ${({ theme }) => theme.colors.success};
    color: ${({ theme }) => theme.colors.background};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.background};
    }
  }
  .Toastify__overwrite-error {
    ${sharedToastStyle}
    background-color: ${({ theme }) => theme.colors.lightDanger};
    color: ${({ theme }) => theme.colors.background};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.background};
    }
    a {
      color: ${({ theme }) => theme.colors.background};
      text-decoration-color: ${({ theme }) => theme.colors.background};
    }
  }
  .Toastify__overwrite-info {
    ${sharedToastStyle}
    background-color: ${({ theme }) => theme.colors.primaryBase};
    color: ${({ theme }) => theme.colors.background};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.background};
    }
  }
  .Toastify__overwrite-default {
    ${sharedToastStyle}
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.primaryText};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.secondaryText};
    }
  }
  .Toastify__agency-share-chat-toast-shared {
    ${sharedToastStyle}
    background-color: ${({ theme }) => theme.colors.success};
    color: ${({ theme }) => theme.colors.background};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.background};
    }
  }
  .Toastify__agency-share-chat-toast-received {
    ${sharedToastStyle}
    background-color: ${({ theme }) =>
      theme.colors.agencyShareChat.toast.bgReceived};
    color: ${({ theme }) => theme.colors.background};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.background};
    }
  }
  .Toastify__agency-share-chat-toast-unread {
    ${sharedToastStyle}
    background-color: ${({ theme }) => theme.colors.primaryBase};
    color: ${({ theme }) => theme.colors.background};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.background};
    }
  }
  .Toastify__mass-disaster-alert {
    ${sharedToastStyle}
    background-color: ${({ theme }) => theme.colors.lightWarningText};
    color: ${({ theme }) => theme.colors.massDisasterToast.text};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.massDisasterToast.text};
    }
  }
  .Toastify__test-incident {
    ${sharedToastStyle}
    background-color: ${({ theme }) => theme.colors.lightWarningText};
    color: ${({ theme }) => theme.colors.massDisasterToast.text};
    button[aria-label='close'] {
      color: ${({ theme }) => theme.colors.massDisasterToast.text};
    }
  }
`;
